// pages/privacy.tsx

import Head from 'next/head';

export default function PrivacyPolicy() {
  return (
    <>
      <Head>
        <title>Privacy Policy | Smart Service</title>
      </Head>
      <div className="max-w-3xl mx-auto px-4 py-10 text-gray-800">
        <h1 className="text-3xl font-bold mb-6">Privacy Policy</h1>

        <p className="mb-4">
          At Smart Service, we are committed to protecting your privacy. This Privacy Policy
          outlines how we collect, use, disclose, and safeguard your information when you visit
          our website or use our services.
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-2">1. Information We Collect</h2>
        <p className="mb-4">
          We may collect personal information such as your name, email address, phone number,
          and any other data you provide through forms, contact requests, or service inquiries.
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-2">2. How We Use Your Information</h2>
        <ul className="list-disc ml-6 mb-4">
          <li>To provide and manage our services</li>
          <li>To communicate with you about your requests</li>
          <li>To improve our website and offerings</li>
          <li>To comply with legal obligations</li>
        </ul>

        <h2 className="text-xl font-semibold mt-8 mb-2">3. Data Sharing and Disclosure</h2>
        <p className="mb-4">
          We do not sell or rent your personal information. We may share your data with trusted
          service providers who assist us in operating our website and services, subject to strict
          confidentiality agreements.
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-2">4. Cookies and Tracking</h2>
        <p className="mb-4">
          Our website may use cookies to enhance your browsing experience. You can set your browser
          to refuse cookies or alert you when cookies are being sent.
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-2">5. Security</h2>
        <p className="mb-4">
          We implement reasonable security measures to protect your personal information, but we
          cannot guarantee absolute security.
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-2">6. Your Rights</h2>
        <p className="mb-4">
          You have the right to access, update, or delete your personal data. To exercise your
          rights, contact us at <a href="mailto:support@smartservice.com" className="text-blue-600 underline">support@smartservice.com</a>.
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-2">7. Changes to This Policy</h2>
        <p className="mb-4">
          We may update this Privacy Policy from time to time. Changes will be posted on this page
          with an updated revision date.
        </p>

        <p className="mt-6">
          <strong>Last Updated:</strong> July 15, 2025
        </p>
      </div>
    </>
  );
}
